<span>{{ referenceId }}</span>
<button class="copy-to-clipboard" (click)="onClickCopy()">Kopier</button>